const VEHICLE_NUMBER_REGEX = /^[A-Z]{2}\d{2}[A-Z]{2}\d{4}$/i;
const LICENSE_NUMBER_REGEX = /^[A-Z]{2}\d{13}$/i;

export { VEHICLE_NUMBER_REGEX, LICENSE_NUMBER_REGEX };
